<template>
    <div class="modal fade text-left" id="emergencyNumbersModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="appointmentModal">{{ $t("labels.emergencyNumbers") }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                  <table class="table table-responsive-sm">
                    <thead>
                      <th>
                        {{ $t("labels.name") }}
                      </th>
                      <th>
                        {{ $t("labels.emergencyNumber") }}
                      </th>
                      <th>
                        {{ $t("labels.emergencyNumberNote") }}
                      </th>
                    </thead>
                    <tbody>
                      <tr v-for="(number, index) in patient.emergencyNumbers" :key="index">
                        <td>
                          {{ number.name }}
                        </td>
                        <td>
                          <a :href="`tel:${number.phone }`">{{ number.phone }}</a>
                        </td>
                        <td>
                          {{ number.note }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeEventModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
      patient: Object,
      required: true
    }
}
</script>



